export const GRID_CATALOG_TYPE_OPTIONS = [
  // ── Copper 200 ──
  "Cu 200‑C R2/2",
  "Cu 200‑C R1/2",
  "Cu 200‑C MultiA",
  "Cu 200‑C (Carbon)",
  // ── Copper 300 ──
  "Cu 300‑C R1.2/1.3",
  "Cu 300‑C R2/1",
  "Cu 300‑C R1/2",
  "Cu 300‑C R1/1",
  "Cu 300‑C (Carbon)",
  "Cu 300‑C R1.2/1.3 (Graphene oxide)",
  // ── Copper 400 ──
  "Cu 400‑C R1.2/1.3",
  "Cu 400‑C (Carbon)",
  "Cu 400‑C Lacey (Carbon)",
  // ── Gold 200 ──
  "Au 200‑Au HexAuFoil",
  "Au 200‑Au R2/2",
  "Au 200‑C R2/4",
  "Au 200‑C R2/4 (Carbon)",
  "Au 200‑C R1/4 (Carbon)",
  "Au 200‑SiO₂ R2/4 (Carbon)",
  "Au 200‑SiO₂ R1/4 (Carbon)",
  "Au 200‑Au Lacey",
  // ── Gold 300 ──
  "Au 300‑Au HexAuFoil",
  "Au 300‑C R1.2/1.3",
  "Au 300‑Au R0.6/1",
  "Au 300‑Au R1.2/1.3",
  "Au 300‑Au R1/1",
];

/** Group labels keyed by first option index — useful for <optgroup> rendering */
export const GRID_CATALOG_TYPE_GROUPS = [
  { label: "Cu 200", start: 0, end: 3 },
  { label: "Cu 300", start: 4, end: 9 },
  { label: "Cu 400", start: 10, end: 12 },
  { label: "Au 200", start: 13, end: 20 },
  { label: "Au 300", start: 21, end: 25 },
];
